import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../../i18n/index.jsx'
import { analytics } from '../../lib/posthog.js'

const STORAGE_KEY = 'cookie_consent_dismissed'

export default function CookieBanner() {
  const { t } = useLanguage()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true)
  }, [])

  if (!visible) return null

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1')
    setVisible(false)
    // Consent given — boot analytics now so the rest of this session is
    // tracked without waiting for a reload. No-op if PostHog isn't configured.
    analytics.enable()
  }

  return (
    <aside
      role="region"
      aria-label={t('cookieBannerAriaLabel')}
      style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
        background: 'var(--bg-surface)', borderTop: '1px solid var(--border-default)',
        padding: '0.875rem 1.5rem', display: 'flex', alignItems: 'center',
        gap: '1rem', flexWrap: 'wrap', fontSize: '0.875rem',
      }}
    >
      <p style={{ flex: 1, margin: 0, color: 'var(--text-secondary)', lineHeight: 1.5, minWidth: 240 }}>
        {t('cookieBannerText')}{' '}
        <Link to="/privacy" style={{ color: 'var(--accent)', textDecoration: 'none' }}>
          {t('cookieBannerLearnMore')}
        </Link>
      </p>
      <button
        onClick={dismiss}
        style={{
          padding: '0.375rem 1.25rem', background: 'var(--accent)', color: 'var(--text-inverse)',
          border: 'none', borderRadius: 'var(--radius)', cursor: 'pointer',
          fontWeight: 500, fontSize: '0.875rem', whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        {t('cookieBannerAccept')}
      </button>
    </aside>
  )
}
